import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';

import { AppPersistantStateService } from '../app-state.service';
import { SaveCurrentCampaignStateHook } from './save-current-campaign-hook';

/**
 * Interface for a connecting an NgRx
 * actions to the persistant state storage
 */
export interface PersistantStateHook {
  attach(actions: Actions, appPersistantStateService: AppPersistantStateService);
  detach();

}

/**
 * Attaches registered hooks to the state service
 */
@Injectable({
  providedIn: 'root'
})
export class PersistantStateHookManager {

  /** Store to prevent multiple attachments */
  private attached = false;

  /**
   * For the time being, placing the all the hooks
   * in here
   */
  initial_hooks: PersistantStateHook[] = [
    new SaveCurrentCampaignStateHook()
  ];

  /**
   *
   */
  constructor(
    private actions: Actions,
    private persistantStateStorage: AppPersistantStateService
  ) {
  }

  attachHooks() {
    if (this.attached) {
      console.warn('Hooks were already attached, to avoiding undesired behavior hooks are not being reattached');
      return;
    }
    this.initial_hooks.forEach((hook) => {
      hook.attach(this.actions, this.persistantStateStorage);
    });

    this.attached = true;
  }

  detatchHooks() {
    this.initial_hooks.forEach((hook) => {
      hook.detach();
    });

    this.attached = false;
  }

}
